import React from "react";
import AdminNav from "./AdminNav";
// import DashboardSearch from './DashboardSearch';
import DashboardTable from './DashboardTable';


function SignUpReport() {
    return (
        <>
            <div className="app-admin-wrap layout-sidebar-large">
                <AdminNav />
                <div className="main-content-wrap d-flex flex-column sidenav-open">
                    <h1>Sign Up Report</h1>

                    {/* <DashboardSearch onSearch={handleSearch} /> */}


                    <DashboardTable title={'Sign Up Report'} event={'signup'} type={"report"} />

                </div>
            </div>
        </>
    );
}

export default SignUpReport;